import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
  locales: ["nb", "en"],
  defaultLocale: "nb",
  localePrefix: "always",
});

export type AppLocale = (typeof routing.locales)[number];
